const US = '\x1f';
const SCRIPT = [
    'git rev-parse --is-inside-work-tree >/dev/null 2>&1 || { echo "@@NOREPO"; exit 0; }',
    'echo "@@LOG"',
    `git log --all --reflog --topo-order --format='%H${US}%P${US}%s${US}%an${US}%at' -n 300 2>/dev/null`,
    'echo "@@REACHABLE"',
    'git rev-list --all 2>/dev/null',
    'echo "@@REFS"',
    `git for-each-ref --format='%(refname)${US}%(objectname)' 2>/dev/null`,
    'echo "@@HEADBRANCH"',
    'git symbolic-ref -q --short HEAD 2>/dev/null',
    'echo "@@HEAD"',
    'git rev-parse -q --verify HEAD 2>/dev/null',
    'echo "@@REFLOG"',
    `git reflog show --format='%H${US}%gd${US}%gs' -n 40 2>/dev/null`,
    'echo "@@STATUS"',
    'git status --porcelain 2>/dev/null',
    'echo "@@END"',
].join('\n');
export const EMPTY_STATE = {
    isRepo: false,
    commits: [],
    refs: [],
    head: { hash: null, branch: null, detached: false },
    reflog: [],
    status: { staged: [], unstaged: [], untracked: [], conflicted: [], clean: true },
};
export async function extractGitState(ws, cwd) {
    const r = await ws.exec(SCRIPT, { cwd, timeoutMs: 15_000 });
    return parseState(r.stdout);
}
function sections(raw) {
    const out = new Map();
    let current = null;
    for (const line of raw.split(/\r?\n/)) {
        if (line.startsWith('@@')) {
            current = [];
            out.set(line.slice(2), current);
        }
        else if (current && line.length > 0) {
            current.push(line);
        }
    }
    return out;
}
export function parseState(raw) {
    const s = sections(raw);
    if (s.has('NOREPO'))
        return EMPTY_STATE;
    const reachable = new Set(s.get('REACHABLE') ?? []);
    const commits = (s.get('LOG') ?? []).map((line) => {
        const [hash = '', parents = '', subject = '', author = '', at = '0'] = line.split(US);
        return {
            hash,
            short: hash.slice(0, 7),
            parents: parents ? parents.split(' ') : [],
            subject,
            author,
            time: Number(at),
            reachable: reachable.has(hash),
        };
    });
    const refs = (s.get('REFS') ?? []).map((line) => {
        const [name = '', hash = ''] = line.split(US);
        let kind = 'other';
        let short = name;
        if (name.startsWith('refs/heads/')) {
            kind = 'branch';
            short = name.slice('refs/heads/'.length);
        }
        else if (name.startsWith('refs/remotes/')) {
            kind = 'remote';
            short = name.slice('refs/remotes/'.length);
        }
        else if (name.startsWith('refs/tags/')) {
            kind = 'tag';
            short = name.slice('refs/tags/'.length);
        }
        return { name, short, hash, kind };
    });
    const branch = (s.get('HEADBRANCH') ?? [])[0] ?? null;
    const headHash = (s.get('HEAD') ?? [])[0] ?? null;
    const reflog = (s.get('REFLOG') ?? []).map((line) => {
        const [hash = '', selector = '', message = ''] = line.split(US);
        return { hash, short: hash.slice(0, 7), selector, message };
    });
    const status = { staged: [], unstaged: [], untracked: [], conflicted: [], clean: true };
    for (const line of s.get('STATUS') ?? []) {
        const x = line[0] ?? ' ';
        const y = line[1] ?? ' ';
        const file = line.slice(3);
        if (x === '?' && y === '?')
            status.untracked.push(file);
        else if (x === 'U' || y === 'U' || (x === 'A' && y === 'A') || (x === 'D' && y === 'D'))
            status.conflicted.push(file);
        else {
            if (x !== ' ')
                status.staged.push(file);
            if (y !== ' ')
                status.unstaged.push(file);
        }
    }
    status.clean =
        status.staged.length + status.unstaged.length + status.untracked.length + status.conflicted.length === 0;
    return {
        isRepo: true,
        commits,
        refs,
        head: { hash: headHash, branch, detached: headHash !== null && branch === null },
        reflog,
        status,
    };
}
//# sourceMappingURL=graph.js.map